import { expandedStates, states } from "../../../../constants/data";
import Styles from "../editScreenStyles.module.css";
import {
  vehicleLocationType,
  vehicleMakes,
  vehicleOwnerOptions,
  yesNo,
} from "../../../../constants/options";

function VehicleEdit({
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {

  const {
    createToggleInput,
    createEditScreenInput,
    createCustomLabelSelect,
    createCustomLabelTextArea
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>The Vehicle</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          {createToggleInput(fields.vehicleIs, "100%", vehicleOwnerOptions, true)}
        </div>

        <div className={Styles.row}>
          {createEditScreenInput(fields.vehicleYear, "100%", Styles.input, Styles.label)}
          {createCustomLabelSelect(
            fields.vehicleMake,
            vehicleMakes.map((make) => make.name),
            Styles.select,
            Styles.label,
            { placeholder: "Select a make" }
          )}
        </div>
        <div className={Styles.row}>
          {createEditScreenInput(fields.vehicleModel, "100%", Styles.input, Styles.label)}
          {createEditScreenInput(fields.vehicleVin, "100%", Styles.input, Styles.label)}
        </div>
        <div className={Styles.row}>
          {createEditScreenInput(fields.vehicleEstimateDamage, "100%", Styles.input, Styles.label)}
        </div>
        {createCustomLabelTextArea(fields.vehicleDescribe, "100%", Styles.textarea, Styles.blockLabel, {altLabel: "Describe the vehicle damage"})}
        {createToggleInput(fields.vehicleDriveable, "100%", yesNo, true)}
        <div className={Styles.hiddenDiv}>
          <p className={Styles.title}>Vehicle Location</p>
          <div className={Styles.row} style={{ marginTop: "0.7rem" }}>
            {createCustomLabelSelect(
              fields.currentLocation,
              vehicleLocationType,
              Styles.select,
              Styles.blockLabel,
              { placeholder: "" }
            )}
          </div>
        </div>
        <div className={Styles.row}>
          {createEditScreenInput(fields.currentLocationVehicleAddress, "100%", Styles.input, Styles.label)}
          {createEditScreenInput(fields.currentLocationVehicleCity, "100%", Styles.input, Styles.label)}
        </div>
        <div className={Styles.row}>
        {createCustomLabelSelect(
            fields.currentLocationVehicleState,
            expandedStates.map((state) => state.Abbr),
            Styles.select,
            Styles.label
            )}
        {createEditScreenInput(fields.currentLocationVehicleZip, "100%", Styles.input, Styles.label)}
        </div>

        <div className={Styles.hiddenDiv}>
          {fields.vehicleIs.value !== vehicleOwnerOptions[0].value && (
            <>
              <p className={Styles.title}>Vehicle Owner Information</p>
              <div className={Styles.row}>
                {fields.vehicleIs.value === vehicleOwnerOptions[1].value ? (
                  <>
                  {createEditScreenInput(fields.rentalCompanyName, "100%", Styles.input, Styles.label)}
                  </>
                ) : (
                  <>
                    {createEditScreenInput(fields.ownedFirstName, "100%", Styles.input, Styles.label)}
                    {createEditScreenInput(fields.ownedLastName, "100%", Styles.input, Styles.label)}
                  </>
                )}
              </div>
              <div className={Styles.row}>
                {createEditScreenInput(fields.nonPolicyVehicleAddress, "100%", Styles.input, Styles.label, {altLabel: "Address"})}
                {createEditScreenInput(fields.nonPolicyVehicleCity, "100%", Styles.input, Styles.label)}
              </div>
              <div className={Styles.row}>
                {createCustomLabelSelect(
                  fields.nonPolicyVehicleState,
                  states,
                  Styles.select,
                  Styles.label,
                  { placeholder: "Select a state"}
                )}
                {createEditScreenInput(fields.nonPolicyVehicleZipCode, "100%", Styles.input, Styles.label)}
                
              </div>
              <div className={Styles.row}>
              {createEditScreenInput(fields.nonPolicyVehiclePhone, "100%", Styles.input, Styles.label)}
              </div>
            </>
          )}
        </div>
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default VehicleEdit;
